import React from 'react'
import PropTypes from 'prop-types'
import commonPropTypes from '../../../constants/commonPropTypes'
import { withApplicationTheme } from '../../applicationTheme'
import { getThemedCompact } from '../util'
import MaskedInputField from '../maskedInputField'
import { createNumberMask } from '../../../utils/inputMasks'
import * as currency from '../../../utils/currency'

const BaseCurrencyInputField = ({
  allowDecimal = true,
  maskOptions = null,
  compact = undefined,
  theme,
  ...rest
}) => {
  const newCompact = getThemedCompact(theme, compact)
  const mask = maskOptions
    ? createNumberMask(maskOptions)
    : allowDecimal
    ? currency.mask
    : currency.noDecimalMask

  return (
    <MaskedInputField
      inputMode='numeric'
      mask={mask}
      normalizeOnBlur={
        allowDecimal ? currency.normalize : currency.normalizeNoDecimal
      }
      {...rest}
      compact={newCompact}
    />
  )
}

BaseCurrencyInputField.propTypes = {
  ...commonPropTypes,
  elmId: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  name: PropTypes.string.isRequired,
  compact: PropTypes.bool,
  allowDecimal: PropTypes.bool,
  maskOptions: PropTypes.object,
}

export default withApplicationTheme(BaseCurrencyInputField)
